import { Box } from '@mui/material';
import SupportTicketLink from 'common/components/SupportTicketLink';
import { useMemo, VFC } from 'react';
import { WarningIcon } from 'common/icons';
import { MessageBox } from '../MessageBox';
import {
  LibraryItemType,
  LibraryItemTypeEnum,
} from './AsyncSharingStatusMessage';

export const FailedMessages = {
  TABLEAU_TITLE_PWC_USER: 'Tableau file failed to clone for client view',
  POWER_PIVOT_TITLE_PWC_USER: 'Excel file failed to clone for client view',
  TITLE_CLIENT_USER: 'Unable to load content',
};

type Props = {
  isPwcUser: boolean;
  type: LibraryItemType;
};
const AsyncFailedStatusMessage: VFC<Props> = ({ isPwcUser, type }) => {
  const title = useMemo(() => {
    if (isPwcUser) {
      if (type === LibraryItemTypeEnum.Tableau) {
        return FailedMessages.TABLEAU_TITLE_PWC_USER;
      }
      if (type === LibraryItemTypeEnum.PowerPivot) {
        return FailedMessages.POWER_PIVOT_TITLE_PWC_USER;
      }
    }
    return FailedMessages.TITLE_CLIENT_USER;
  }, [isPwcUser, type]);

  const message = useMemo(() => {
    if (isPwcUser) {
      return (
        <>
          Please <SupportTicketLink>create a support ticket</SupportTicketLink>{' '}
          for assistance with this issue.
        </>
      );
    }

    return (
      <>
        Please try again later. If the issue continues, please contact the
        Engagement Lead or Engagement Manager.
      </>
    );
  }, [isPwcUser]);

  return (
    <MessageBox
      borderColor={{
        dark: 'var(--color-red-error-light)',
        light: 'var(--color-red-error-light)',
      }}
    >
      <Box
        sx={{ display: 'flex', alignItems: 'center', mb: '1rem' }}
        data-testid="async-sharing-status-message-failed"
      >
        <WarningIcon />
        <Box sx={{ ml: '0.75rem', fontSize: '1.125rem', fontWeight: 'bold' }}>
          {title}
        </Box>
      </Box>
      <div data-testid="async-sharing-status-message__content-failed">
        {message}
      </div>
    </MessageBox>
  );
};

export default AsyncFailedStatusMessage;
